(function () {
  'use strict';

  if (window.GGSMotion) return;

  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var observer = null;

  function prefersReducedMotion() {
    return reduceQuery ? reduceQuery.matches : false;
  }

  function clearMotionStyles(element) {
    if (!element) return;
    element.classList.remove('ggs-motion-run');
    element.classList.add('is-in');
    element.style.removeProperty('opacity');
    element.style.removeProperty('visibility');
    element.style.removeProperty('transform');
    element.style.removeProperty('will-change');
    element.style.removeProperty('transition-delay');
    element.style.removeProperty('--ggs-delay');
    element.style.removeProperty('--ggs-duration');
    element.style.removeProperty('--ggs-distance');
  }

  function revealScope(scope) {
    (scope || document).querySelectorAll('[data-ggs-anim]').forEach(clearMotionStyles);
  }

  function animateElement(element, group, index) {
    if (!element || element.dataset.ggsAnimated === 'true') return;

    element.dataset.ggsAnimated = 'true';

    var delay = Math.max(0, index * group.stagger);
    var duration = Math.max(200, group.duration);
    var distance = group.style === 'fade' ? 0 : group.hero ? 18 : 26;
    var guard = window.setTimeout(function () {
      clearMotionStyles(element);
    }, delay + duration + 1400);

    if (group.gsap && window.gsap) {
      try {
        var startState = {
          y: distance,
          willChange: 'transform, opacity'
        };

        if (!group.hero) startState.autoAlpha = 0;

        window.gsap.fromTo(element, startState, {
          autoAlpha: 1,
          y: 0,
          duration: duration / 1000,
          delay: delay / 1000,
          ease: 'power3.out',
          clearProps: 'opacity,visibility,transform,willChange',
          onComplete: function () {
            window.clearTimeout(guard);
            clearMotionStyles(element);
          }
        });
        return;
      } catch (error) {
        clearMotionStyles(element);
      }
    }

    element.style.setProperty('--ggs-delay', delay + 'ms');
    element.style.setProperty('--ggs-duration', duration + 'ms');
    element.style.setProperty('--ggs-distance', distance + 'px');
    element.classList.add('ggs-motion-run');

    window.setTimeout(function () {
      window.clearTimeout(guard);
      clearMotionStyles(element);
    }, delay + duration + 120);
  }

  function animateSection(section) {
    if (!section || section.dataset.ggsPlayed === 'true') return;

    section.dataset.ggsPlayed = 'true';

    var elements = section.querySelectorAll('[data-ggs-anim]');
    if (!elements.length) return;

    var group = {
      duration: parseInt(section.dataset.duration || '700', 10),
      stagger: parseInt(section.dataset.stagger || '90', 10),
      style: section.dataset.ggsStyle || 'rise',
      gsap: section.dataset.gsap !== 'false',
      hero: section.classList.contains('ggs-hero')
    };

    elements.forEach(function (element, index) {
      animateElement(element, group, index);
    });
  }

  function isNearViewport(section) {
    var rect = section.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewport * 0.92 && rect.bottom > 0;
  }

  function register(section) {
    if (!section || section.dataset.ggsRegistered === 'true') return;

    section.dataset.ggsRegistered = 'true';

    if (prefersReducedMotion() || section.dataset.animate === 'false') {
      revealScope(section);
      return;
    }

    if (isNearViewport(section)) {
      animateSection(section);
      return;
    }

    if ('IntersectionObserver' in window) {
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animateSection(entry.target);
            observer.unobserve(entry.target);
          });
        }, {
          rootMargin: '0px 0px 12% 0px',
          threshold: 0.01
        });
      }

      observer.observe(section);
      return;
    }

    animateSection(section);
  }

  function registerAll(scope) {
    (scope || document).querySelectorAll('[data-ggs-section]').forEach(register);
  }

  function setMinDates(scope) {
    (scope || document).querySelectorAll('input[type="date"][data-min-days]').forEach(function (input) {
      var days = parseInt(input.dataset.minDays || '0', 10);
      var date = new Date();
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + days);
      input.min = date.toISOString().slice(0, 10);
    });
  }

  function openLightbox(src, alt) {
    var box = document.querySelector('.ggs-lightbox');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ggs-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<button class="ggs-lightbox__close" type="button" aria-label="Close">×</button><img alt="">';
      document.body.appendChild(box);
      box.addEventListener('click', function (event) {
        if (event.target === box || event.target.closest('.ggs-lightbox__close')) closeLightbox();
      });
    }

    var image = box.querySelector('img');
    image.src = src;
    image.alt = alt || '';
    box.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    box.querySelector('button').focus();
  }

  function closeLightbox() {
    var box = document.querySelector('.ggs-lightbox');
    if (box) box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function boot(scope) {
    registerAll(scope);
    setMinDates(scope);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ggs-lightbox]');
    if (!trigger) return;
    event.preventDefault();
    openLightbox(trigger.dataset.full || trigger.getAttribute('href'), trigger.dataset.alt || '');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (observer && event.target.matches('[data-ggs-section]')) observer.unobserve(event.target);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) revealScope(document);
  });

  if (reduceQuery && reduceQuery.addEventListener) {
    reduceQuery.addEventListener('change', function (event) {
      if (event.matches) revealScope(document);
    });
  }

  window.GGSMotion = {
    register: register,
    registerAll: registerAll,
    revealAll: function () {
      revealScope(document);
    }
  };
})();
